<template>
    <section class="list">
        <ul
            v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="50" v-if="articleList.length>0"
        >
            <li
                class="flex flex-main-justify"
                v-for="(article, index) in articleList"
                @click="goPath(article)"
                :key="index"
            >
                
                <div v-if="article.type === 'live'" style="width:100%">
                    <div class="title"><span class="tag_label" v-if="article.tags  && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                    <!-- liveType直播类型 1有视频无图 2有图无视频 3无图无视频 -->
                    <div class="pic-wrap" v-if="article.liveType != 3 && (article.liveImage||article.images)">
                        <img :src="article.liveImage || article.images[0]" alt="" style="max-width:100%">
                        <!-- liveStatus || status直播状态 1预告 2直播中 3已结束 -->
                        <!-- <div :class="['status','status-' + article.liveStatus]">{{article.liveStatus==1?'预告':(article.liveStatus==2?'直播中':'已结束')}}</div> -->
                        <div :class="['status','status-' + article.liveStatus]"></div>
                    </div>
                    <div class="flex flex-main-justify date">
                        <span>{{getDate(article.date) | dateCompared}}</span>
                        <span v-if="article.hits > 0">{{article.hits}}人参与</span>
                    </div>
                </div>
                <!-- 三图 -->
                <div v-if="article.viewType==='three'" style="height:100%;width:100%;">
                    <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                    <div class="three-list flex">
                        <div class="img" v-for="img in article.images" :key="img" :style="{backgroundImage: 'url(' + img + ')'}"></div>
                        <!-- <div class="images-label" v-if="article.type === 'image'">{{article.medias && article.medias.length>0 ?article.medias.length : 0}}图</div> -->
                    </div>
                   <div class="flex-default date" style='justify-content: flex-start;'>
                        <div class="tag ellipsis" >
                            <span v-if="article.source">{{article.source}}</span>
                        </div>
                        <span>{{getDate(article.date) | dateCompared}}</span>
                        <!-- <span class="tag-like" v-if="article.type != 'link'">{{article.likes}}</span> -->
                    </div>
                </div>
                <div v-else-if="article.viewType==='bannerSmall'" style="width:100%;">
                    <div class="img-frame-small">
                    <div class="img-bac" v-if="article.images" :style="'background:url('+article.images[0]+') no-repeat;background-size:100%'"></div>
                    </div>
                </div>
                <div v-else-if="(article.viewType==='banner' || article.viewType==='bigimage') && article.type!= 'live'" style="height:100%;width:100%">
                    <!-- 新闻 -->
                    <div v-if="article.type === 'normal' || article.type==='subject'">
                        <div class="pic-wrap">
                            <img :src="article.image" alt="">
                        </div>
                        <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                        <div class="description" v-html="article.description"></div>
                        <div class="flex-default date" style='justify-content: flex-start;'>
                            <div class="tag ellipsis" >
                                <span v-if="article.source">{{article.source}}</span>
                            </div>
                            <span>{{getDate(article.date) | dateCompared}}</span>
                            <!-- <span class="tag-like" v-if="article.type != 'link'">{{article.likes}}</span> -->
                        </div>
                    </div>
                    <!-- 视频 -->
                    <div v-else-if="article.type === 'video'">
                        <div class="title"><span class="tag_label" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                        <div class="pic-wrap">
                            <img :src="article.images[0]" alt="">
                            <i class="content-button"></i>
                        </div>
                        <div class="flex-default date" style='justify-content: flex-start;'>
                            <div class="tag ellipsis" >
                                <span v-if="article.source">{{article.source}}</span>
                            </div>
                            <span>{{getDate(article.date) | dateCompared}}</span>
                            <!-- <span class="tag-like" v-if="article.type != 'link'">{{article.likes}}</span> -->
                        </div>
                    </div> 
                    <!-- 话题 -->
                    <div v-else-if="article.type === 'theme'">
                        <div class="pic-wrap" v-if="article.images">
                            <img :src="article.images[0]" alt="">
                            <div class="images-label" v-if="article.type === 'image'">{{article.medias && article.medias.length>0 ?article.medias.length : 0}}图</div>
                        </div>
                        <div class="title"><span class="tag_theme">#话题</span>{{article.listTitle || article.title}}</div>
                        <div class="description" v-html="article.description"></div>
                        <div class="flex-default date" style='justify-content: flex-start;'>
                            <div class="tag ellipsis" >
                                 <span v-if="article.source">{{article.source}}</span>
                            </div>
                            <span >{{getDate(article.date) | dateCompared}}</span>
                            <!-- <span class="tag-like" v-if="article.type != 'link'">{{article.likes}}</span> -->
                        </div>
                    </div>
                    <div v-else>
                        <div class="pic-wrap" v-if="article.images">
                            <img :src="article.images[0]" alt="">
                            <div class="images-label" v-if="article.type === 'image'">{{article.medias && article.medias.length>0 ?article.medias.length : 0}}图</div>
                        </div>
                        <div class="title">{{article.listTitle || article.title}}</div>
                        <div class="description" v-html="article.description"></div>
                        <div class="flex date ellipsis">
                            <span class="tag" v-if="article.source">{{article.source}}</span>
                            <span class="tag">{{getDate(article.date) | dateCompared}}</span>
                            <!-- <span class="tag-like" v-if="article.type != 'link'">{{article.likes}}</span> -->
                        </div>
                    </div>
                </div>
                <!-- 图集 -->
                <!-- <div v-else-if="article.type === 'image'">
                    <div class="title" v-html="article.title"></div>
                    <div class="flex images-list">
                        <div class="images" v-for="img in article.medias.slice(0,4)" :style="{backgroundImage: 'url(' + img.image + ')'}"></div>
                        <div class="images-label" v-if="article.medias.length>3">{{article.medias.length}}图</div>
                    </div>
                </div> -->
                <!-- 左文右图 -->
                <template v-else>
                    <div class="info" v-if="article.type!= 'live'">
                        <div :class='["title", "mult_line_ellipsis",article.images && article.images.length>0?"min_height":""]' ><span class="tag_label_2" v-if="article.tags && article.type==='subject'">{{article.tags}}</span>{{article.listTitle || article.title}}</div>
                        <div class="flex date">
                            <div class="tag ellipsis" style=' justify-content: flex-start'>
                                <span v-html="article.source"></span>
                            </div>
                            <time>{{getDate(article.date) | dateCompared}}</time>
                        </div>
                        
                        <!-- <div class="flex date ellipsis">
                            <span class="tag" v-if="article.source">{{article.source}}</span>
                            <span class="tag">{{getDate(article.date) | dateCompared}}</span>
                             <span class="tag-like" v-if="article.type != 'link'">{{article.likes}}</span>
                        </div> -->
                    </div>
                    <div 
                        class="thumbnail" 
                        :style="{backgroundImage: 'url(' + article.images[0] + ')'}" 
                        v-if="article.images && article.viewType!='noimage' && article.type!= 'live'"
                    >
                        <i class="video-icon" v-if="article.type=='video' && article.medias">{{article.medias[0].times}}</i>
                        <i class="image-icon" v-if="article.type=='image' && article.medias">{{article.medias.length}}</i>
                        <i class="audio-icon" v-else-if="article.type=='audio' && article.medias">{{article.medias[0].times}}</i>
                    </div>
                </template>
            </li>
        </ul>
        <div v-else class="null-data">暂无相关内容</div>
        <p v-if="loading" class="loading">
            <spinner type="fading-circle"></spinner>
            加载中...
        </p>
        <p v-if="isAll" class="loading">已显示全部内容</p>
    </section>
</template>

<script>
import api from "src/constants/appapi";
// import audio from "_images/btn_audio@2x.png";
import { Toast,Spinner,InfiniteScroll } from "mint-ui";
import { intfc_prefix_common } from 'constants/project'
import subjectSwipe from "../com-list-swipe";
export default {
    data() {
        return {
            isSharePage: false, // 是否为分享页面
            articleList:[],
            loading: false,
            isAll: false,
            data:{
                page: {
                    last: 2
                }
            },
            next: 1,
            pageToken:''
        }
    },
    created() {
        window.appapi = api;
        this.isSharePage = appapi.isSharePage();
    },

    mounted() {
        this.getArticles()
    },

    methods: {
        
        getDate: (date) => {
            return date.slice(0, -2) + ':00'
        },
        // getDate:(date)=>{
        //     return moment(date).format('HH:mm')
        // },

        goPath (article) {
            if (!this.isSharePage) {
                const { 
                    listTitle, 
                    pushDate, 
                    source, 
                    likes, 
                    imageUrl, 
                    articleId, 
                    type, 
                    sysCode 
                } = article;
                
                const obj = {
                    listTitle, 
                    pushDate, 
                    source, 
                    likes, 
                    imageUrl, 
                    articleId: articleId,
                    type: type,
                    sysCode: sysCode
                }
                window.appapi.appPostMessage("goNewsDetail", JSON.stringify(obj));
            }else {
                window.location.href = article.shareUrl.slice(article.shareUrl.indexOf("://")+1);
            }
        } ,
        getArticles (id, index, size=5) {
            this.loading = true
            this.pageToken = this.next * 1
            const pageLast = this.data.page.last * 1
            console.log(pageLast)
            if ( this.pageToken > pageLast) {
                this.loading = false
                this.isAll = true
                return false
            }
             this.$axios.get(`${intfc_prefix_common}/api/v2/articles/recommentPage?articleId=${this.$route.params.id}&pageToken=${this.pageToken}&size=5`)
                .then(res=> {
                    const result = res
                    if (res.code === 0) {
                        this.data = result
                        this.loading = false
                        if (this.data.item && this.data.item.list.length > 0){
                            console.log('this.data.item.list',this.data.item.list)
                            this.articleList.push(...this.data.item.list)
                        }
                        this.next++
                    } else {
                        Toast(res.msg)
                        this.loading = false
                    }
                })
        },

        
        loadMore() {
            // console.log(this.isAll,'isAll',this.loading,'this.loading')
            if (this.isAll || this.loading) return false
            this.getArticles(this.$route.params.id)
        }, 
        
        // getType (obj) {

        //     return 'video-bg'
        // }
    },
    components:{
        subjectSwipe,
        spinner: Spinner,
    }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin"
    @import "~src/stylus/reset";
    @import "~src/stylus/list";
    .list 
        margin-top 50px
    .loading 
        padding-bottom 50px
        text-align center
        font-size 24px
        color #AFAFAF
        height 56px
        line-height 56px
    .null-data 
        margin: 50px auto 0;
        padding-top: 244px;
        width 244px
        height 80px
        text-align center
        font-size 24px
        color #AFAFAF
        line-height 80px
        background url("~images/no-comment.png") no-repeat 50% top/244px auto 
    .app-null-data 
        padding-top: 233px;
        width 227px
        background url("~images/null.png") no-repeat 50% top/227px auto
    .share-null-data 
        padding-top: 233px;
        width 227px
        background url("~images/null.png") no-repeat 50% top/227px auto
    .status {
        position: absolute;
        display: block;
        left: 32px;
        top: 30px;
        // padding: 6px 20px;
        // font-size: 24px;
        // color: #fff;
        // border-radius:8px;
        // transform: scale(0.8);
        width 122px
        height 60px
        
        &.status-1 {
            // background-color: #ffaf56;
            background url("~images/label-pre-live.png") no-repeat 50%/100%
             
        }
        &.status-2 {
            // background-color: #64d59d;
            background url("~images/label-living.png") no-repeat 50%/100%
        }
        &.status-3 {
            // background-color: #cacaca;
            background url("~images/label-living-over.png") no-repeat 50%/100%
        }
    }
</style>


// WEBPACK FOOTER //
// theme-list-article.vue?101cc60a